export const COMPLETE_REGISTRATION_REQUEST = 'COMPLETE_REGISTRATION_REQUEST';
export const COMPLETE_REGISTRATION_SUCCESS = 'COMPLETE_REGISTRATION_SUCCESS';
export const COMPLETE_REGISTRATION_FAILURE = 'COMPLETE_REGISTRATION_FAILURE';

export const LOGGED_IN = 'LOGGED_IN';
export const LOGOUT = 'LOGOUT';
